import { observer } from "mobx-react";
import { Fragment, h } from "preact";
import { t, translate } from "../I18n";
import Alert from "./Alert";
import RadioField from "./RadioField";
import SelectField from "./SelectField";
function FulfillmentTimeForm(props) {
    const { fulfillmentTime, controller, nextAvailableOrderingDate, onChange } = props;
    const { isEditable } = fulfillmentTime;
    return (h(Fragment, null,
        nextAvailableOrderingDate !== null && (h(Alert, { type: "info", icon: "info-sign", message: translate(t.restaurants.widgets.cart.opening_hour, {
                hour: nextAvailableOrderingDate,
            }) })),
        isEditable && (h(FulfillmentTimeOptions, { fulfillmentTime: fulfillmentTime, controller: controller, onChange: onChange }))));
}
/**
 * Contains Radio field with fulfillment time options with sub-options for OnTime and OnDateAndTime
 */
const FulfillmentTimeOptions = observer((props) => {
    const { fulfillmentTime, controller, onChange } = props;
    const { options } = fulfillmentTime;
    const { fulfillmentOption, fulfillmentDate, fulfillmentHour } = controller.fields;
    const optionsWithChildren = options.map((option) => ({
        value: option.type,
        label: option.label,
        children: getOptionChildren(option, fulfillmentDate, fulfillmentHour, onChange),
    }));
    return (h(RadioField, { name: "fulfillmentTime", dataFieldId: "fulfillmentTime", controller: fulfillmentOption, options: optionsWithChildren, label: translate(t.activerecord.attributes.order.deliver_at), onChange: onChange }));
});
function getOptionChildren(option, dateField, hourField, onChange) {
    switch (option.type) {
        case "ASAP":
            return undefined;
        case "Today":
            return (h(SelectField, { controller: hourField, options: option.timeOptions, name: "order_deliver_at", dataFieldId: "deliverAt", label: translate(t.activerecord.attributes.order.deliver_at), placeholder: translate(t.orders.form.choose_time), hideLabel: true, onChange: onChange }));
        case "InFuture":
            return (h(Fragment, null,
                h(SelectField, { name: "order_deliver_at_date", dataFieldId: "deliverAtDate", controller: dateField, options: option.dateOptions, disabled: option.dateDisabled, label: translate(t.orders.form.choose_date), placeholder: translate(t.orders.form.choose_date), hideLabel: true, onChange: onChange }),
                h(SelectField, { name: "order_deliver_at_time", dataFieldId: "deliverAt", controller: hourField, options: option.timeOptions, disabled: option.timeDisabled, label: translate(t.orders.form.choose_time), placeholder: translate(t.orders.form.choose_time), hideLabel: true, onChange: onChange })));
    }
}
export default observer(FulfillmentTimeForm);
